import React, { useEffect, useState } from "react";
import { Routes, Route } from "react-router-dom";
import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import { loginRequest } from "../config";
import { Layout } from "../layout/Layout";
import { Dashboard } from "../modules/dashboard/Dashboard";
import { AnalysisModule } from "../modules/analysis/AnalysisModule";
import GeneDiseaseLinkFixed from "../modules/gene/GeneDiseaseLinkFixed";
import GeneHubFixed from "../modules/gene/GeneHubFixed";
import DiseaseHubFixed from "../modules/gene/DiseaseHubFixed";

export const App: React.FC = () => {
  const { instance, accounts } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const [authResolved, setAuthResolved] = useState(accounts.length > 0);

  useEffect(() => {
    if (accounts.length > 0) {
      instance.setActiveAccount(accounts[0]);
      setAuthResolved(true);
      return;
    }

    const resolveAuth = async () => {
      try {
        await instance.initialize();
        const result = await instance.ssoSilent(loginRequest);
        instance.setActiveAccount(result.account);
        setAuthResolved(true);
      } catch {
        // No active session — redirect to Azure AD.        
        await instance.loginRedirect(loginRequest);
      }
    };

    resolveAuth();
  }, [instance, accounts]);

  if (!authResolved && !isAuthenticated) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-blue-500 mx-auto mb-3" />
          <p className="text-sm text-gray-500">Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/gene-hub" element={<GeneHubFixed />} />
        <Route path="/disease-hub" element={<DiseaseHubFixed />} />
        <Route path="/analytics/analysis" element={<AnalysisModule />} />
        <Route
          path="/research/gene-disease-link"
          element={<GeneDiseaseLinkFixed />}
        />
      </Routes>
    </Layout>
  );
};
